<div id="acom">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="inner-card">
                    <h4 class="card-title">School Hours and School Timing</h4>
                    <div class="card-body text-justify">
                            <h5>SUMMER (Monday to Saturday)</h5>
                            <hr class="pb-1 rounded">
                            <table class="table table-bordered table-hover">
                                <thead>
                                  <tr>
                                    <th scope="col">S.No.</th>
                                    <th scope="col">Class</th>
                                    <th scope="col">Timing</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <th scope="row">1</th>
                                    <td>Pre-Nursery to K.G.</td>
                                    <td>8.00 a.m. to 12.00 Noon</td>
                                  </tr>
                                  <tr>
                                    <th scope="row">2</th>
                                    <td>I & II</td>
                                    <td>8.00 a.m. to 12.40 p.m.</td>
                                  </tr>
                                  <tr>
                                    <th scope="row">3</th>
                                    <td>lll to VIII</td>
                                    <td>8.00 a.m. to 2.00 p.m.</td>
                                  </tr>
                                  <tr>
                                    <th scope="row">4</th>
                                    <td>IX & X</td>
                                    <td>7.25 a.m. to 2.00 p.m.</td>
                                  </tr>
                                  <tr>
                                    <th scope="row">5</th>
                                    <td>XI & XII</td>
                                    <td>7.25 a.m. to 12.40 p.m.</td>
                                  </tr>
                                </tbody>
                              </table>
                              <h5>WINTER (Monday to Saturday)</h5>
                            <hr class="pb-1 rounded">
                            <table class="table table-bordered table-hover">
                                <thead>
                                  <tr>
                                    <th scope="col">S.No.</th>
                                    <th scope="col">Class</th>
                                    <th scope="col">Timing</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <th scope="row">1</th>
                                    <td>Pre-Nursery to K.G.</td>
                                    <td>8.30 a.m. to 12.30 noon </td>
                                  </tr>
                                  <tr>
                                    <th scope="row">2</th>
                                    <td>I & II</td>
                                    <td>8.30 a.m. to 1.15 p.m.</td>
                                  </tr>
                                  <tr>
                                    <th scope="row">3</th>
                                    <td>lll to VIII</td>
                                    <td>8.30 a.m. to 2.30 p.m. </td>
                                  </tr>
                                  <tr>
                                    <th scope="row">4</th>
                                    <td>IX & X</td>
                                    <td>7.55 a.m. to 2.30 p.m.</td>
                                  </tr>
                                  <tr>
                                    <th scope="row">5</th>
                                    <td>XI & XII</td>
                                    <td>7.55 a.m. to 1.15 p.m.</td>
                                  </tr>
                                </tbody>
                              </table>
                    </div>
                </div>

            </div>
        </div>

       
    </div>
</div>